/* eslint-disable import/prefer-default-export */

export const ACTUACIONES_PAE_ENUM = {
  GENERADO: 1,
  INVITACION: 2,
  OTRO: 3,
  INICIO_PAE: 4,
  NOTIFICACION_PAE: 5,
  EMBARGO_PAE: 6,
  REMATE_PAE: 7,
  OTRO_PAE: 8,
  CONCLUIDO_PAE: 9,
  PAGO: 10,
  PAGO_ABONADO: 11,
  PAGO_SALDADO: 12,
  CANCELO_PAGO: 13,
  LITIGIO: 14,
  CANCELADO: 15,
  TERMINADO: 16,
};
